import React from 'react';
import { Card, CardContent } from './ui/card';
import { Award, Users, Wrench, Handshake } from 'lucide-react';

const WhyChoose = () => {
  const reasons = [
    {
      icon: Award,
      title: 'Industry-Experienced Trainers',
      description: 'Learn from professionals with real-world experience in cloud, AI, and enterprise technology.',
    },
    {
      icon: Users,
      title: 'Hands-On, Real-World Approach',
      description: 'Project-based learning with practical applications that prepare you for actual challenges.',
    },
    {
      icon: Wrench,
      title: 'End-to-End Services',
      description: 'From training to placement, recruitment to software development - we cover it all.',
    },
    {
      icon: Handshake,
      title: 'Long-Term Partnership',
      description: 'We build lasting relationships focused on continuous growth and success.',
    },
  ];

  return (
    <section id="why-choose" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0B0F1A]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 font-['Space_Grotesk']">
            Why Choose <span className="bg-gradient-to-r from-[#00E5FF] to-[#1DE9B6] bg-clip-text text-transparent">CloudXAI</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#00E5FF] to-transparent mx-auto mb-4"></div>
          <p className="text-xl text-[#9CA3AF] max-w-3xl mx-auto">
            Your trusted partner in digital transformation and career growth
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <Card key={index} className="bg-[#111827] border-2 border-[#00E5FF]/20 hover:border-[#00E5FF]/60 hover:shadow-xl hover:shadow-[#00E5FF]/20 transition-all duration-300 group">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-6">
                    <div className="flex-shrink-0 w-16 h-16 rounded-2xl bg-gradient-to-br from-[#00E5FF] to-[#1DE9B6] flex items-center justify-center group-hover:shadow-lg group-hover:shadow-[#00E5FF]/50 transition-all duration-300">
                      <Icon className="w-8 h-8 text-[#0B0F1A]" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white mb-3 font-['Space_Grotesk'] group-hover:text-[#00E5FF] transition-colors">{reason.title}</h3>
                      <p className="text-[#9CA3AF] leading-relaxed">{reason.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
